import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Disclaimer from "./Disclaimer";

const HeroKycIntro = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    try {
      sessionStorage.removeItem("isAuthenticated");
    } catch {}
    navigate("/video-login", { replace: true });
  };

  return (
    <>
      <section
        className="relative min-h-[70vh] flex items-center justify-center px-4"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/MainBody04.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Logout */}
        <button
          onClick={handleLogout}
          className="absolute top-6 right-6 btn-white px-5"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/White2.png)`,
          }}
        >
          Logout
        </button>

        {/* Glass Card */}
        <div
          className="max-w-3xl w-full text-center p-10 rounded-3xl text-white"
          style={{
            background: "rgba(0,0,0,0.6)",
            backdropFilter: "blur(12px)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.7)",
          }}
        >
          <h2 className="text-4xl font-bold text-purple-400 mb-4">
            Welcome to Video KYC
          </h2>

          <p className="text-gray-300 mb-8">
            Complete your KYC process quickly, securely, and conveniently.
          </p>

          <div className="flex items-center justify-center gap-3 mb-8">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
              className="scale-125 accent-purple-500"
            />
            <span className="text-sm text-gray-200">
              I confirm that the details provided will be valid.
            </span>
          </div>

          <button
            disabled={!isChecked}
            onClick={() => setShowDisclaimer(true)}
            className="btn-black px-10 py-3"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/Black2.png)`,
              opacity: isChecked ? 1 : 0.4,
            }}
          >
            Start Video KYC Application
          </button>
        </div>
      </section>

      {/* ✅ Disclaimer shown on SAME PAGE */}
      {showDisclaimer && (
        <Disclaimer
          onReject={() => setShowDisclaimer(false)}
          onAccept={() => navigate("/kyc-form")}
        />
      )}
    </>
  );
};

export default HeroKycIntro;
